/**
 * FinalTestPage.tsx
 * -----------------
 * Page wrapper for the final test component.
 */


import Layout from '../components/common/Layout';
import FinalTest from '../components/FinalTest';

const FinalTestPage = () => {
  return (
    <Layout>
      <FinalTest />
    </Layout>
  );
};

export default FinalTestPage;
